import { AuthNetEnvironment } from "react-acceptjs";

export const useAPIURL = () => process.env.REACT_APP_AGENT_API_URL || "";
export const useAPI_LOGIN_ID = () => process.env.REACT_APP_API_LOGIN_ID || "";
export const useCLIENT_KEY = () => process.env.REACT_APP_CLIENT_KEY || "";
export const useAuthorizeEnv = (): AuthNetEnvironment => process.env.REACT_APP_AUTHORIZE_ENV === "PRODUCTION" ? "PRODUCTION" : "SANDBOX";